import { render, staticRenderFns } from "./NotePill.vue?vue&type=template&id=187d3b6d&"
import script from "./NotePill.vue?vue&type=script&lang=js&"
export * from "./NotePill.vue?vue&type=script&lang=js&"
import style0 from "./NotePill.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports